export enum CreateNewChaseAction {
  Validate = 0,
  Save = 1,
}
